<div class="container-fluid" id="divConteudoAcompanhamento">
    <div class="row">
        <fieldset  class="col_sm_12 border well well-sm" id="fstDadosGerais">
            <legend class="float-none" style="width:auto;">Acompanhamento de Inscrição</legend>
            <div class="row mb-1">
                <div class="col-sm-3 mb-1">
                    <label class="input-group-text pb-0" style="display:block;">
                        Nº {{dtoAcompanhamento.inscricao}}{{v_situacaoInscricao}}
                    </label>
                </div>
                <div class="col-sm-3 mb-1"  *ngIf="dtoAcompanhamento.indCotista">
                    <div class="input-group input-group-sm">
                        <label class="input-group-text etiqueta1">Cotista</label>
                        <label class="form-control" title="Tipo de costista">{{dtoAcompanhamento.descricaoTipoCotista}}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                        <label class="input-group-text etiqueta1" >CPF</label>
                        <label class="form-control" title="CPF do candidato">{{dtoAcompanhamento.cpf}}</label>
                    </div>
                </div>
                <div class="col-sm-9 mb-1">
                    <div class="input-group input-group-sm">
                        <label class="input-group-text etiqueta1">Nome</label>
                        <label class="form-control" title="Nome do candidato">{{dtoAcompanhamento.nome}}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">RG</label>
                    <label class="form-control" title="RG do candidato">{{dtoAcompanhamento.rg}} / {{dtoAcompanhamento.rgOrgao}} {{(dtoAcompanhamento.rguf != '' ? ' - ' + dtoAcompanhamento.rguf : '')}}</label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">OAB</label>
                    <label class="form-control" title="OAB do candidato">
                        {{dtoAcompanhamento.numOAB}} {{(dtoAcompanhamento.orgaoExpOAB == '' ? '' : ' / ' + dtoAcompanhamento.orgaoExpOAB )}}
                    </label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">Sexo</label>
                    <label class="form-control" title="Sexo do candidato">{{dtoAcompanhamento.sexo}}</label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">Escrita</label>
                    <label class="form-control" title="Escrita do candidato">{{dtoAcompanhamento.escrita}}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1" style="padding-right:0;" title="Telefone Residencial do candidato">Tel. Res.</label>
                    <label class="form-control" title="Telefone Residencial do candidato">{{dtoAcompanhamento.telefoneResidencial}}</label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1" style="padding-right:0;"  title="Telefone Comercial do candidato">Tel. Com.</label>
                    <label class="form-control" title="Telefone Comercial do candidato">{{dtoAcompanhamento.telefoneComercial}}</label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">Celular</label>
                    <label class="form-control" title="Celular do candidato">{{dtoAcompanhamento.telefoneCelular}}</label>
                    </div>
                </div>
                <div class="col-sm-3 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text etiqueta1">E-mail</label>
                    <label class="form-control" title="E-mail do candidato">{{dtoAcompanhamento.email}}</label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-6 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text">Necessidades especiais</label>
                    <label class="form-control" title="Necessidades Especiais do candidato">
                        {{(dtoAcompanhamento.deficiencia == 'Sim' ? 'Sim - ':'Não')}}{{dtoAcompanhamento.descricaoDeficiencia}}
                    </label>
                    </div>
                </div>
                <div class="col-sm-6 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text">Necessita de apoio</label>
                    <label class="form-control" title="Candidato necessita de apoio">
                        {{(dtoAcompanhamento.necessitaApoio == 'S' ? 'Sim':'Não')}}
                        {{(dtoAcompanhamento.apoio != '' ? ' - ' + dtoAcompanhamento.apoio :'')}}
                    </label>
                    </div>
                </div>
            </div>
            <div class="row mb-1">
                <div class="col-sm-6 mb-1">
                    <div class="input-group input-group-sm">
                        <label class="input-group-text">
                            <input type="checkbox" id="chksms" disabled>
                        </label>
                        <label class="form-control" contenteditable="false" readonly="true">
                            Autorizo o envio de informações via SMS.
                        </label>
                    </div>
                </div>
                <div class="col-sm-6 mb-1">
                    <div class="input-group input-group-sm">
                        <label class="input-group-text">
                            <input type="checkbox" id="chkpos" disabled>
                        </label>
                        <label class="form-control" contenteditable="false" readonly="true">
                            Aceito receber e-mails sobre os cursos de extensão e pós-graduação da EMERJ
                        </label>
                    </div>
                </div>
            </div>
            <div class="row mb-0" *ngIf="textoAlocacao!=''">
                <div class="col-sm-12 mb-1">
                    <div class="input-group input-group-sm">
                    <label class="input-group-text">Local de prova</label>
                    <label class="form-control"
                    title="Local de Prova"
                    [innerHTML]="textoAlocacao"></label>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>
    <form [formGroup]="documentoCotistaForm">
    <div class="row border mt-1 mb-1 p-0 well well-sm" *ngIf="dtoAcompanhamento.indCotista">

            <div class="col-sm-2 p-0 m-1">
                <div class="input-group input-group-sm">
                    <label class="input-group-text">
                        <input type="checkbox" id="chkir" formControlName="IR" [disabled]="false" >
                    </label>
                    <label class="form-control" contenteditable="false" readonly>Isento de IR.</label>
                </div>
            </div>
            <div class="col-sm-2 p-0 m-1">
                <div class="input-group input-group-sm">
                    <label class="input-group-text">
                        <input type="checkbox" id="chkDesempregado" formControlName="DESEMPREGADO" [disabled]="false" >
                    </label>
                    <label class="form-control" contenteditable="false" readonly>Está desempregado.</label>
                </div>
            </div>
    </div>
    <div class="row" *ngIf="dtoAcompanhamento.indCotista">
        <fieldset class="col_sm_12 border mt-0 mb-1 p-0 well well-sm" id="fstDadosGerais">
            <legend  class="float-none" style="width:auto;">
                Documentos - Cotista
                <span id="lblTxtSpanDoc" class="fw-bold" (click)="mostrarEsconderDoc()">{{textoSpanDoc}}</span>
            </legend>
            

                <div *ngIf="exibirDocs" id="divDocs">
                    <div id="docs" class="row m-1 mt-0 mb-1"
                        *ngFor="let doc of docs.get('DocumentoCotista')['controls'];
                                let i = index; 
                                let even = even; 
                                let odd = odd;" [ngClass]="odd ? 'even' : 'even'">
                            <div class="col-sm-10" style="padding:0px!important;">
                                    <label style="display:block;padding:4px;border-radius:2px;border:1px solid silver ; margin:4px 12px;background-color:ivory;">{{doc.value.descDoc}}</label>
                            </div>
                            <div class="col-sm-2" style="padding:0px!important;">
                                <div id="displayBotoes">
                                    <div style="display:inline-block; min-width:70px!important;text-align:left;">
                                        <label [ngClass]="getClassSituacao(doc.value.situacao)" >
                                            {{(doc.value.situacao == 'ACEITO' ? 'Deferido' : (doc.value.situacao == 'REJEITADO' ? 'Indeferido' : doc.value.situacao))}}
                                        </label>
                                    </div>
                                    <div style="display:inline;margin: 0px 10px;">
                                        <span id="btnComentario"
                                            class="fa fa-comment noprint"
                                            aria-hidden="true" 
                                            *ngIf="doc.value.situacao=='REJEITADO'" 
                                            (click)="abrirPopUpMotivo(doc.value.motivoRejeicao)">
                                        </span>
                                        <span id="btnComentario" 
                                            class="noprint"
                                            aria-hidden="true" 
                                            *ngIf="doc.value.situacao!=='REJEITADO'">
                                            &nbsp;&nbsp;
                                        </span>
                                    </div>
                                    <div *ngIf="doc.value.situacao!=='Não Enviado'" style="display:inline;" >
                                        <span id="btnDownload" 
                                            class="fa fa-download noprint"
                                            aria-hidden="true" 
                                            (click)="downloadDoc(doc.value.urlGedDownload);"></span>
                                    </div>
                                </div>
                            </div>
                            <div class="row m-0" style="padding:0px!important;" *ngIf="dtoAcesso.ind_prazoConcurso=='LIBERAR_COTISTA'">
                                <div class="m-0 mb-1 p1">
                                    <input type="file" 
                                    id="formFileSm+{{i}}" 
                                    #fileInput
                                    (change)="uploadFile({files: fileInput.files, index: i, event: $event, value: doc.value.codDoc})"
                                    class="form-control form-control-sm" title="">
                                </div> 
                            </div>
                    </div>
                </div>
                <div class="row m-1 p-1" *ngIf="dtoAcesso.ind_prazoConcurso=='LIBERAR_COTISTA'">
                    <button id="btnAvancar"
                            type="button" 
                            [disabled]="!habilitarBtnEnviar"
                            (click)="Enviar()"  
                            class="btn btn-primary btn-sm azulTopo w-auto">
                        <span class="fa fa-upload noprint">&nbsp;Enviar Documentos</span>
                    </button>
                </div>
          
        </fieldset>
    </div>
</form>
    <div class="row">
        <fieldset class="col_sm_12 border well well-sm mt-0 mb-1 p-0">
            <legend  class="float-none">Atenção</legend>
            <ol class="m-0 mb-0 pt-0">
                <li>O recolhimento da taxa de inscrição será através de boleto bancário.</li>
                <li>A confirmação da inscrição só se dará após 3 dias úteis da efetivação do pagamento.
                    Dúvidas relacionadas ao pagamento da taxa de inscrição poderão ser encaminhadas para o e-mail emerjprovadeselecao@tjrj.jus.br.</li>
                <li>Anote o número da sua inscrição, pois será através deste número que será feito o acompanhamento da mesma.</li>
                <li>A situação da sua inscrição deverá ser acompanhada pelo site da EMERJ.</li>
            </ol>
        </fieldset>
    </div>
    <div class="row noprint" >
        <div class="col-sm-1 mt-0 mb-1 p-0 d-grid noprint" style="padding-right:4px!important;">
            <button type="button"
                    id="btnVoltar"
                    class="btn btn-primary btn-sm azulTopo noprint"
                    (click)="paginaAnterior()">
                    <span class="fa fa-arrow-left ">&nbsp;Voltar</span>
            </button>
        </div>
        <div class="col-sm-1 mt-0 mb-1 p-0 d-grid noprint" style="padding-right:4px!important;">
            <button type="button"
                    id="btnImprimir"
                    class="btn btn-primary btn-sm azulTopo noprint"
                    (click)="imprimirAcompanhamento()">
              <span class="fa fa-print">&nbsp;Imprimir</span>
            </button>
        </div>
        <div class="col-sm-1 mt-0 mb-1 p-0 d-grid noprint"
             style="padding-right:4px!important;"
             *ngIf="dtoAcompanhamento.exibeBotaoBoleto">
            <button type="button"
                    id="btnImprimir"
                    class="btn btn-primary btn-sm azulTopo noprint"
                    (click)="imprimirBoletoBinario()">
              <span class="fa fa-barcode">&nbsp;Boleto</span>
            </button>
        </div>
        <div class="col-sm-1 mt-0 mb-1 p-0 d-grid noprint"
             style="padding-right:4px!important;"
             *ngIf="dtoAcompanhamento.liberarMatricula">
            <button type="button"
                    id="btnImprimir"
                    class="btn btn-primary btn-sm azulTopo noprint" (click)="redirecionarPrematricula()">
              <span class="fa fa-archive">&nbsp;Matricular</span>
            </button>
        </div>
      </div>
</div>